import { render, staticRenderFns } from "./exhibition-moment.vue?vue&type=template&id=8a981f14&scoped=true&"
import script from "./exhibition-moment.vue?vue&type=script&lang=js&"
export * from "./exhibition-moment.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-moment.vue?vue&type=style&index=0&id=8a981f14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a981f14",
  null
  
)

export default component.exports